import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { FindFieldComponent } from '../find-field/find-field.component';
import { ComponentRef, ModalOptions } from '@ionic/core';
import { ParcelInquiryComponent } from '../parcel-inquiry/parcel-inquiry.component';
import { ClientAlertService } from 'src/app/core/services/client-alert.service';
import { LanguageService } from 'src/app/core/services/lang.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { environment } from 'src/environments/environment';
import { ImportFarmDeviceService } from '../../services/import-farm-device.service';

@Component({
  selector: 'app-pick-device-type-pair',
  templateUrl: './pick-device-type-pair.component.html',
  styleUrls: ['./pick-device-type-pair.component.scss'],
})
export class PickDeviceTypePairComponent implements OnInit {
  loadStorage: boolean = false;
  isFilizMode: boolean = false;
  type: string;
  queryParam: Subscription;
  mode: string;
  savedFarmItem: any;
  constructor(private router: Router, private storageService: StorageService, private modalService: ModalService,
    private alertService: ClientAlertService, private langService: LanguageService, private loadingService: LoadingService,
    private activatedRoute: ActivatedRoute, private importDevicFarmService: ImportFarmDeviceService) { }
  //Tarla paylaşma süreci burada

  ngOnInit() { }

  later() {
    this.router.navigateByUrl("/common/later-page");
  }
  ionViewDidLeave() {
    this.loadStorage = false;
    this.queryParam.unsubscribe();
  }

  ionViewDidEnter() {
    this.storageService.remove(StorageKeys.DRAWING).then();
    this.storageService.get(StorageKeys.FILIZ_MODE).then(res => {
      if (res.IsSuccess) {
        this.isFilizMode = res.Data;
      }
      setTimeout(() => {
        this.loadStorage = true;
        this.queryParam = this.activatedRoute.queryParams.subscribe(e => {
          if (e["type"]) {
            this.type = e["type"];
            if (this.type == "import-field") {
              this.openAddField();
            }
          }
        });
      }, 200);
    });

  }

  openAddField() {
    this.modalService.presentModal({
      component: FindFieldComponent,
      componentProps: {
        type: this.type,
        isFilizMode: this.isFilizMode
      },
      options: {
        initialBreakpoint: 0.8,
        swipeToClose: false,
        mode: "ios",
        cssClass: "modal-radius"

      } as ModalOptions<ComponentRef>
    }).then(response => {
      response.modalObj.onDidDismiss().then(dismissProps => {
        if (dismissProps) {
          if (dismissProps.role == "startParcelInquiry") {
            this.startParcelInquery();
          } else if (dismissProps.role == "drawLocationSelected") {
            this.router.navigate(["/common/add-field"], {
              queryParams: { type: dismissProps.role }
            });
          } else if (dismissProps.role == "importFarm") {

            this.mode = dismissProps.role;
            // this.initialPage = 4;
            this.savedFarmItem = dismissProps.data;
            this.importFarm();

          } else if (dismissProps.role == "addDevice") {

            this.mode = dismissProps.role;
            // this.initialPage = 2;
            this.savedFarmItem = dismissProps.data;
            this.router.navigate(["/common/enter-device"], {
              queryParams: {
                initialPage: 2,
                mode: this.mode,
                tempFarmAttrId: this.savedFarmItem.TempFarmAttId
              }
            });
          }

        }
      });
    });
  }


  importFarm() {
    this.loadingService.showLoading();
    if (this.savedFarmItem.CampaingId != environment.campaignId || this.savedFarmItem.CampaingId != 195) {
      this.importDevicFarmService.shareFarm({ TempFarmAttId: this.savedFarmItem.TempFarmAttId }).subscribe(e => {
        this.loadingService.hideLoading();
        if (e.IsSuccess) {
          if (this.savedFarmItem.Info) {
            // this.initialPage = 4;
            if (this.isFilizMode) {
              this.storageService.lastFilizFarmId = this.savedFarmItem.TempFarmAttId;
              this.storageService.set(StorageKeys.LAST_FILIZ_FARM, this.storageService.lastTrapFarmId);
            } else {
              this.storageService.lastTrapFarmId = this.savedFarmItem.TempFarmAttId;
              this.storageService.set(StorageKeys.LAST_TRAP_FARM, this.storageService.lastFilizFarmId);
            }
            this.router.navigate(["/common/enter-device"], {
              queryParams: {
                initialPage: 4
              }
            });
          } else {
            // this.initialPage = 2;
            if (this.isFilizMode) {
              this.storageService.lastFilizFarmId = this.savedFarmItem.TempFarmAttId;
              this.storageService.set(StorageKeys.LAST_FILIZ_FARM, this.storageService.lastTrapFarmId);
            } else {
              this.storageService.lastTrapFarmId = this.savedFarmItem.TempFarmAttId;
              this.storageService.set(StorageKeys.LAST_TRAP_FARM, this.storageService.lastFilizFarmId);
            }
            this.mode = "addDevice";
            this.storageService.lastFilizFarmId = null;
            this.storageService.lastTrapFarmId = null;
            this.router.navigate(["/common/enter-device"], {
              queryParams: {
                initialPage: 2,
                mode: this.mode,
                tempFarmAttrId: this.savedFarmItem.TempFarmAttId
              }
            });
          }
        } else {
          this.mode = "addDevice";
          this.router.navigate(["/common/enter-device"], {
            queryParams: {
              initialPage: 2,
              mode: this.mode,
              tempFarmAttrId: this.savedFarmItem.TempFarmAttId
            }
          });
        }
      });
    } else {
      this.router.navigate(["/common/enter-device"], {
        queryParams: {
          initialPage: 4
        }
      });
    }
  }

  startParcelInquery() {
    this.modalService.presentModal({
      component: ParcelInquiryComponent,
      componentProps: {},
      options: ModalService.defaultOptions
    }).then(response => {
      response.modalObj.onDidDismiss().then(dismissResponse => {
        if (dismissResponse.role == 'canceled') {
          this.openAddField()
        } else if (dismissResponse.role == 'areaFound') {
          this.router.navigate(["/common/add-field"], {
            queryParams: { type: "parcelInquery" }
          });

        } else if (dismissResponse.role == 'areaNotFound') {
          let inquiryAgainCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
            this.startParcelInquery()
          }

          let cancelCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
            this.openAddField()
          }
          this.alertService.PresentAlert({
            buttons: [
              { callback: inquiryAgainCallback, color: "primary", fill: "solid", text: this.langService.getTranslation("add_field.inquiry_again_btn") },
              { callback: cancelCallback, color: "dark", fill: "clear", text: this.langService.getTranslation("general.cancel") }
            ],
            description: this.langService.getTranslation("add_field.parcel_not_found_desc"),
            title: this.langService.getTranslation("add_field.parcel_not_found_title"),
            image: "assets/images/not_found_image_1.svg"
          }, false).then(response => { })
        }
      });
    });
  }








}
